import LogisticsPageHero from '../Logistics/LogisticsPageHero';

const ABOUT_HERO_IMG =
  '/aboutpageimages/aboutus-hero-image.webp';

const AboutUsHero = () => (
  <LogisticsPageHero
    ariaLabel="About Pick Pack Pro UK fulfilment"
    imageSrc={ABOUT_HERO_IMG}
    imageAlt="Pick Pack Pro UK fulfilment company — e-commerce and Amazon FBA services"
    titleLight="About Pick Pack Pro"
    titleAccent="UK E-Commerce Fulfilment Partner"
    description={
      <>
        <p>
          Pick Pack Pro is a trusted UK e-commerce fulfilment partner, helping Amazon, Shopify and multi-channel brands
          scale with reliable warehousing, Amazon FBA prep and fast order fulfilment from our Milton Keynes hub.
        </p>
      </>
    }
    features={[
      '1M+ Orders Packed',
      '99.9% Client Satisfaction',
      '5+ Years of Fulfilment Expertise',
      'Milton Keynes Fulfilment Hub',
      'Amazon, Shopify & TikTok Ready',
    ]}
    primaryCta={{ label: 'Get a quote', to: '/contact-fulfillment-services' }}
    secondaryCta={{ label: 'Our fulfilment centre', to: '/our-fulfilment-center' }}
  />
);

export default AboutUsHero;
